import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const DanalResultMob = () => {
  return <CommonResult />;
};

export default DanalResultMob;
